<template>
  <tr
    :class="
      (selected ? ' selected' : '') +
        (small ? ' caption' : '') +
        (dark ? ' background dark--border-y' : '')
    "
  >
    <th
      @click="$emit('click')"
      :class="{
        'dark--border-r': true,
        'text-left': true,
        'font-weight-bold': count || bold,
        'font-weight-regular': !(count || bold),
        clickable: clickable,
        'cursor-pointer': clickable,
        caption: small,
        background: dark
      }"
    >
      <div :class="{ 'pl-8': indent }">
        <span :class="{ 'dashed-bottom': !selected && clickable && expand }">
          {{ t2(title) }}
          <v-icon small color="secondary" class="ml-2" v-if="expand">
            {{ !selected ? "vertical_align_bottom" : "vertical_align_top" }}
          </v-icon>
        </span>
        <slot name="titleExtension"></slot>
      </div>
    </th>
    <th
      :class="{
        'font-weight-bold': true,
        'dark--border-r': true,
        'cursor-pointer': true
      }"
      @click="$emit('cellclick', standard_value)"
    >
      <div
        :class="{ 'white--border': !dark, 'pa-2': standard_value.hideValues }"
        v-bind:style="{
          backgroundColor: backgroundColor
        }"
      >
        <template v-if="count">
          {{ standard_value.value | no_decimal }}
        </template>
        <template v-else-if="!standard_value.value">
          NA
        </template>
        <template v-else>
          {{ standard_value.value | one_decimal }}
        </template>
      </div>
    </th>
    <heatmap-cell
      v-for="(value, j) in values"
      :key="j + 'cell'"
      :value="value"
      :count="count"
      :small="small"
      :dark="dark"
      :class="{ 'd-none': value.hide }"
      @click="$emit('cellclick', value)"
    ></heatmap-cell>
    <td>&nbsp;</td>
  </tr>
</template>

<script>
import HeatmapCell from "@/components/common/HeatmapCell";
export default {
  name: "HeatmapRow",
  props: {
    title: { type: String },
    standard_value: { type: Object },
    values: { type: Array },
    count: { type: Boolean, default: false },
    bold: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    indent: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    expand: { type: Boolean, default: false }
  },
  components: { HeatmapCell },
  computed: {
    backgroundColor() {
      let color = "#fff";
      let opacity = 1;
      if (this.dark) {
        color = this.$vuetify.theme.themes.light.background;
      } else if (
        !this.count &&
        !this.standard_value.hideValues &&
        this.standard_value.value > 0
      ) {
        color = this.$coreScores.getColor(this.standard_value.value);
        opacity = this.$coreScores.getOpacity(this.standard_value.value);
      }

      return this.getColor(color, opacity);
    }
  }
};
</script>
